import { useRef, type RefObject } from 'react'

import { InfiniteInsightItem } from '../types/infiniteLanding.types'
import { INFINITE_LANDING_INSIGHT_CAROUSEL_ITEMS } from '../utils/infiniteLandingInsightsData'

export function useInfiniteInsightsCarousel(): {
  scrollRef: RefObject<HTMLDivElement | null>
  carouselItems: InfiniteInsightItem[]
  onCarouselScroll: () => void
} {
  const scrollRef = useRef<HTMLDivElement | null>(null)
  const carouselItems = INFINITE_LANDING_INSIGHT_CAROUSEL_ITEMS

  const onCarouselScroll = () => {
    return
  }

  return { scrollRef, carouselItems, onCarouselScroll }
}
